import React from 'react';

const DesktopLayout = ({ children, styles, onClose }) => {
    // `children` is an array when the caller passes multiple elements, but a
    // single element (NOT an array) when it passes one — e.g. ComposePage's
    // `resolving` branch renders just the nav button while a triaged thought
    // loads. Destructuring a lone element throws ("undefined is not a
    // function"), which white-screened the whole app. Normalize to an array.
    const [navigationButton, thoughtEditor, actionButtons] =
        Array.isArray(children) ? children : [children];

    return (
        <>
            <div 
                style={styles.composePage.desktop.overlay}
                onClick={onClose}
            />
            
            <div style={styles.composePage.desktop.container}>
                <div style={styles.composePage.desktop.header}>
                    {navigationButton}
                    <div style={styles.composePage.desktop.buttonContainer}>
                        {actionButtons}
                    </div>
                </div>
                
                <div style={styles.composePage.desktop.textareaContainer}>
                    {thoughtEditor}
                </div>

                <style>{`
                    div::-webkit-scrollbar {
                        display: none;
                    }
                `}</style>
            </div>
        </>
    );
};

export default DesktopLayout; 